<template>
    <div ref="modal" class="modal fade add-product-modal-popup" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">×</span>
                    </button>
                    <h4 class="modal-title p-0-30" id="modal-title">Add product</h4>
                    <div class="description p-0-30">
                        Select a product from the list below or add a custom product.
                        Only products linked to this service are listed.
                    </div>
                    <div class="custom-search-container p-0-30">
                        <span class="fa fa-search"></span>
                        <input MaxLength="200" class="form-control"
                               type="text" v-model="searchValue"
                               placeholder="Type product name to search"/>
                    </div>
                    <div class="modal-body modal-body-assign">
                        <div id="keywords-result">
                            <ul class="menu">
                                <li class="custom-product">
                                    <div class="row">
                                        <a class="col-sm-12 p-bottom-10" href="javascript:;" @click="addCustomProduct">
                                            + Add Custom Product
                                        </a>
                                    </div>
                                </li>
                                <li class="service-list menu" v-for="serviceProduct of filteredProducts">
                                    <div class="">
                                        <div class="checkbox-list">
                                            <label class="products-service-list-label">
                                                <span class="checked col-xs-1">
                                                        <input v-model="selectedProducts" type="checkbox"
                                                               :value="serviceProduct.id">
                                                </span>
                                                <span class="col-xs-9">{{ serviceProduct.product }}</span>
                                                <span class="col-xs-2"> +${{ serviceProduct.product_cost }}</span>
                                            </label>

                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div id="navbarCollapse" class="navbar-collapse">
                        <ul class="nav navbar-nav navbar-right">
                            <li>
                                <input type="button" data-dismiss="modal" value="Cancel"
                                       class="btn btn-settings-cancel pull-right topLinks cancel mobile-width-100"/>
                            </li>
                            <li>
                                <input type="button" value="Add" @click="submit"
                                       class="btn btn-primary btn-primary-settings pull-right topLinks mobile-width-100">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import {getServiceProducts} from "@/modules/Services/api/products";
import {EventBus} from "@/events/event-bus";

export default {
    name: "AddProductModal",
    props: {
        id: {
            required: true
        },
        service: {
            required: true,
            type: Object
        },
        itemId:null,
        autoAssigned:{
            type: Array,
            default:[]
        },
        serviceBookingProducts:{
            type: Array,
            default:[]
        }
    },
    data() {
        return {
            serviceProducts: [],
            selectedProducts: [],
            customProduct: true,
            searchValue: ''
        }
    },
    methods: {
        addCustomProduct(event) {
            event.stopPropagation()
            EventBus.$emit('onCustomProductAdded', this.customProduct,this.service.service_id,this.service.clone)
            $(this.$refs['modal']).modal('toggle')
        },
        submit(event) {
             event.stopPropagation()
            EventBus.$emit('onProductsSelected', this.selectedProducts,this.service.service_id,this.service.clone)
            $(this.$refs['modal']).modal('toggle')
        },
        selectAutoAssignedProducts(){
            if (this.serviceBookingProducts.length > 0 ){
                let selectedProductsTmp = [];
                for (let single of this.serviceBookingProducts){
                  selectedProductsTmp.push(single);
                  this.selectedProducts.push(single.product_id);
                }
                EventBus.$emit('onServiceProductsSelected', selectedProductsTmp,this.service)
            }

              else if (this.autoAssigned.length > 0  ){
                  for (let single of this.autoAssigned){
                    this.selectedProducts.push(single.id);
                  }
                  EventBus.$emit('onProductsSelected', this.selectedProducts,this.service.service_id,this.service.clone)
              }
        }
    },
    computed: {
        filteredProducts() {
            if (this.searchValue !== '' && this.searchValue) {
                return this.serviceProducts.filter((item) => {
                    return item.product
                        .toUpperCase()
                        .includes(this.searchValue.toUpperCase())
                })
            }
            return this.serviceProducts
        }
    },
    mounted() {

        this.selectAutoAssignedProducts();

        EventBus.$on('show_all_product_in_popup', product => {
            getServiceProducts(this.service.service_id)
                .then(response => {
                    if (response.data) {
                        this.serviceProducts = response.data
                    }
                })
        });




        EventBus.$on('onSelectedProductDeleteConfirm', productId => {
            const index = this.selectedProducts.indexOf(productId);
            if (index > -1) {
                this.selectedProducts.splice(index, 1);
            }
        });


    }


}
</script>

<style scoped>
.float-e-margins .btn{
    margin-bottom: 5px;
}
@media (max-width: 768px) {
    .mobile-width-100{
        width: 100% !important;
    }
    .modal-header{
        padding-left: 0px !important;
    }
}
</style>